import { callBackendFunction } from '../../services/paymentService';
import type { ConsentSelection, ConsentSource, StoredConsentSummary } from './legalConfig';
import { getCurrentLegalVersions } from './legalConfig';

export type RecordLegalAcceptanceRequest = {
  source: ConsentSource;
  email?: string | null;
  selection: ConsentSelection;
  metadata?: Record<string, unknown>;
};

export type RecordLegalAcceptanceResponse = {
  success: boolean;
  eventId: string;
  summary: StoredConsentSummary;
};

export type UpdateConsentPreferencesRequest = {
  analyticsCookiesAccepted: boolean;
};

export type UpdateConsentPreferencesResponse = {
  success: boolean;
  eventId: string;
  summary: StoredConsentSummary;
};

export type SetMarketingConsentRequest = {
  email: string;
  granted: boolean;
  source: Extract<ConsentSource, 'profile' | 'newsletter'>;
  locale?: string | null;
  metadata?: Record<string, unknown>;
};

export type SetMarketingConsentResponse = {
  success: boolean;
  eventId: string;
  status: 'subscribed' | 'already_subscribed' | 'updated';
  summary: {
    consentType: 'marketing';
    granted: boolean;
    source: 'profile' | 'newsletter';
    actorType: string;
    locale?: string | null;
    email: string;
    lastEventId: string;
    status: 'subscribed' | 'already_subscribed' | 'updated';
  };
};

export async function recordLegalAcceptance(request: RecordLegalAcceptanceRequest) {
  return callBackendFunction<RecordLegalAcceptanceRequest, RecordLegalAcceptanceResponse>('recordLegalAcceptance', request);
}

export async function updateConsentPreferences(request: UpdateConsentPreferencesRequest) {
  return callBackendFunction<UpdateConsentPreferencesRequest, UpdateConsentPreferencesResponse>('updateConsentPreferences', request);
}

export async function setMarketingConsent(request: SetMarketingConsentRequest) {
  return callBackendFunction<SetMarketingConsentRequest, SetMarketingConsentResponse>('setMarketingConsent', request);
}

export function buildConsentPayload(selection: ConsentSelection) {
  return {
    ...getCurrentLegalVersions(),
    ...selection,
  };
}